import React, {useState} from 'react';
import './Panel.css';
import boldIcon from '../assets/svgs/letter-b.svg';
import underlineIcon from '../assets/svgs/underline-text.svg';
import italicIcon from '../assets/svgs/italic.svg';
import linkIcon from '../assets/svgs/link.svg';

function Panel({panelTop, panelRight, panelLink, applyCommand, handleLinkClick, handleIframeLinkClick, removeLink, webviewmode}) {
  const [activeButton, setActiveButton] = useState("");

  const handleClick = (command) => {
    if (activeButton === command) {
      applyCommand(command);
      setActiveButton("");
    } else {
      applyCommand(command);
      setActiveButton(command);
    }
  };

 

  return (
    <div className="panel" style={{
      padding: "0px",
      position: "fixed",
      top: `${panelTop + 30}px`,
      left: webviewmode ? `${panelRight - 120}px` : `${(panelRight) + (window.innerWidth/2) - 120}px`
    }} draggable="true">
      {!panelLink ? 
      <>
        <button className={activeButton === "bold" ? "active" : ""} onClick={() => handleClick("bold")}>
          <img src={boldIcon} alt="bold-icon"/>
        </button>
        <button style={{borderRight:"1px solid #D8B0E0", borderLeft:"1px solid #D8B0E0"}} className={activeButton === "italic" ? "active" : ""} onClick={() => handleClick("italic")}>
          <img src={italicIcon} alt="italic-icon"/>
        </button>
        <button style={{borderRight:"1px solid #D8B0E0"}} className={activeButton === "underline" ? "active" : ""} onClick={() => handleClick("underline")}>
          <img src={underlineIcon} alt="underline-icon"/>
        </button>
        <button onClick={handleLinkClick}>
        <img src={linkIcon} alt="link-icon"/>
        </button>
        </>
      
      :
      // for editing links only
      <>
        <button style={{width:"100%"}} onClick={handleIframeLinkClick}>Edit Link</button>
        <button onClick={removeLink}><i className="bi bi-trash-fill"></i></button>
      </>
      

        }
      
    </div>
  );
}

export default Panel;
